<template>
    <div class="mt-3 seat-pax-info">
        <h5>{{ $t('Asignación de asientos') }}</h5>
        <div class="card shadow itin">
            <div class="itin-flight" v-if="headerTitle">
                <div class="itin-subheader">
                    <div class="row">
                        <div class="col text-left" v-if="flightNumber">
                            <h5 class="mb-0">{{ $t('Vuelo') }} O4 {{flightNumber}}</h5>
                        </div>
                        <div class="col text-right">
                            <h5 class="mb-0"><strong>{{headerTitle}}</strong></h5>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pax-seat-info-table">
                <div class="pax-seat-row pax-seat-header">
                    <div class="pax-seat-name">{{ $t('Pasajero') }}</div>
                    <div class="pax-seat-code">{{ $t('Asiento') }}</div>
                    <div class="pax-seat-value">{{ $t('Valor') }}</div>
                    <div class="pax-seat-actions"></div>
                </div>

                <div
                  class="pax-seat-row pax-seat-item"
                  :class="{'is-current': isCurrent(pax)}"
                  v-for="pax in paxs"
                  :key="pax.segId + '-' + pax.pax.PassengerID"
                  @click="onSelect(pax)"
                >
                    <div class="pax-seat-name">
                        {{pax.pax.LastName}} {{pax.pax.FirstName}}
                    </div>
                    <div class="pax-seat-code">
                        <span class="seat-badge" v-if="pax.paxLeg.UnitDesignator">{{pax.paxLeg.UnitDesignator}}</span>
                        <span class="seat-empty" v-else>—</span>
                    </div>
                    <div class="pax-seat-value">
                        <template v-if="priceParts(pax)">
                            <span class="seat-diff-label" v-if="priceParts(pax).isDifference">Dif.</span>
                            <span class="seat-currency">{{priceParts(pax).currency}}</span>
                            <span class="seat-amount">{{priceParts(pax).amount}}</span>
                        </template>
                        <span class="seat-empty" v-else>—</span>
                    </div>
                    <div class="pax-seat-actions">
                        <button
                          v-if="canClear(pax)"
                          type="button"
                          class="seat-clear-btn"
                          :title="$t('Cancelar asiento')"
                          @click.stop="onClear(pax)"
                        >×</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: "SeatSelectPassenger",
    props: {
      paxs: { type: Array, default: function () { return []; } },
      currentPax: { default: null },
      prices: { type: Object, default: function () { return {}; } },
      routeLabel: { type: String, default: '' },
    },
    computed: {
      ...mapState(['booking', 'checkinFlight', 'segmentsToCheck']),
      flightNumber: function () {
        if (this.checkinFlight && this.checkinFlight.Legs && this.checkinFlight.Legs[0]
            && this.checkinFlight.Legs[0].InventoryLeg) {
          return this.checkinFlight.Legs[0].InventoryLeg.FlightNumber;
        }
        let pax = this.currentPax || (this.paxs && this.paxs[0]);
        if (pax && pax.paxLeg && pax.paxLeg.InventoryLeg) {
          return pax.paxLeg.InventoryLeg.FlightNumber;
        }
        return null;
      },
      headerTitle: function () {
        if (this.routeLabel) return this.routeLabel;
        if (this.checkinFlight) {
          return this.checkinFlight.DepartureStation + ' → ' + this.checkinFlight.ArrivalStation;
        }
        let pax = this.currentPax || (this.paxs && this.paxs[0]);
        if (pax && pax.segment) {
          return pax.segment.DepartureStation + ' → ' + pax.segment.ArrivalStation;
        }
        return '';
      },
    },
    methods: {
      isCurrent: function (pax) {
        return this.currentPax
          && pax.segId == this.currentPax.segId
          && pax.pax.PassengerID == this.currentPax.pax.PassengerID;
      },
      isCharter: function (pax) {
        if (pax && pax.segment && pax.segment.IsCharter) return true;
        if (pax && pax.paxLeg && pax.paxLeg.InventoryLeg && pax.paxLeg.InventoryLeg.IsCharter) return true;
        if (this.checkinFlight && this.checkinFlight.IsCharter) return true;
        if (this.checkinFlight && this.checkinFlight.Legs && this.checkinFlight.Legs[0]
            && this.checkinFlight.Legs[0].InventoryLeg && this.checkinFlight.Legs[0].InventoryLeg.IsCharter) {
          return true;
        }
        return false;
      },
      isSeatFee: function (fee) {
        return Number(fee.FeeType) === 9 || (fee.Fee && Number(fee.Fee.FeeType) === 9)
          || fee.FeeCode === 'SEAT' || (fee.Fee && fee.Fee.FeeCode === 'SEAT');
      },
      hasUnpaidSeatFee: function (pax) {
        if (!pax || !pax.segment || !pax.segment.Fees) return false;
        return pax.segment.Fees.some((fee) => this.isSeatFee(fee) && !fee.PaymentID);
      },
      hasPaidSeatFee: function (pax) {
        if (!pax || !pax.segment || !pax.segment.Fees) return false;
        return pax.segment.Fees.some((fee) => this.isSeatFee(fee) && fee.PaymentID);
      },
      canClear: function (pax) {
        if (!pax || !pax.paxLeg || !pax.paxLeg.UnitDesignator) return false;
        if (this.hasUnpaidSeatFee(pax)) return true;
        if (this.hasPaidSeatFee(pax)) return false;
        return true;
      },
      unpaidSeatAmount: function (pax) {
        if (!pax || !pax.segment || !pax.segment.Fees) return 0;
        let total = 0;
        for (let fee of pax.segment.Fees) {
          if (!this.isSeatFee(fee) || fee.PaymentID) continue;
          for (let charge of fee.Charges || []) {
            if (charge.ChargeType == 3) continue;
            let k = charge.ChargeType == 1 ? -1 : 1;
            total += parseFloat(charge.ChargeAmount || 0) * k;
          }
        }
        return total;
      },
      priceParts: function (pax) {
        if (this.isCharter(pax)) return null;
        let seat = pax.paxLeg && pax.paxLeg.UnitDesignator;
        if (!seat) return null;
        let unpaid = this.unpaidSeatAmount(pax);
        let info = this.prices && this.prices[seat];
        let amount = unpaid > 0 ? unpaid : (info ? Number(info.Amount || 0) : 0);
        if (!amount && !info) return null;
        let currency = (info && info.CurrencyId) || 'ARS';
        return {
          currency: currency,
          amount: amount.toLocaleString('es-AR', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          }),
          isDifference: unpaid > 0 && this.hasPaidSeatFee(pax),
        };
      },
      onSelect: function (selectedPax) {
        this.$emit('select-pax', selectedPax);
      },
      onClear: function (pax) {
        this.$emit('clear-seat', pax);
      }
    },
  }
</script>

<style scoped>
.pax-seat-info-table {
  padding: 8px 12px 16px;
}
.pax-seat-row {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) 72px minmax(96px, 1fr) 36px;
  gap: 8px;
  align-items: center;
  padding: 10px 12px;
  border-radius: 6px;
}
.pax-seat-header {
  font-weight: 700;
  color: #333;
  font-size: 14px;
  padding-bottom: 6px;
}
.pax-seat-item {
  cursor: pointer;
  margin-top: 4px;
  transition: background-color 0.15s ease;
}
.pax-seat-item:hover:not(.is-current) {
  background: #f5f5f5;
}
.pax-seat-item.is-current {
  background-color: #cc353a;
  color: #fff;
}
.pax-seat-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pax-seat-code,
.pax-seat-value {
  text-align: center;
}
.pax-seat-value {
  display: flex;
  justify-content: flex-end;
  align-items: baseline;
  gap: 4px;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.seat-currency {
  font-size: 11px;
  opacity: 0.85;
  letter-spacing: 0.02em;
}
.seat-diff-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  opacity: 0.9;
}
.seat-amount {
  font-weight: 700;
  font-size: 14px;
}
.seat-badge {
  display: inline-block;
  min-width: 36px;
  padding: 2px 8px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.08);
  font-weight: 700;
}
.pax-seat-item.is-current .seat-badge {
  background: rgba(255, 255, 255, 0.22);
}
.seat-empty {
  opacity: 0.55;
}
.pax-seat-actions {
  display: flex;
  justify-content: center;
  align-items: center;
}
.seat-clear-btn {
  width: 28px;
  height: 28px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  background: #fff;
  color: #AA1E1E;
  font-size: 18px;
  line-height: 1;
  padding: 0;
  cursor: pointer;
}
.pax-seat-item.is-current .seat-clear-btn {
  border-color: rgba(255, 255, 255, 0.55);
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
}
.seat-clear-btn:hover {
  background: #AA1E1E;
  border-color: #AA1E1E;
  color: #fff;
}
</style>
